import { MarketCountryCode } from '@backmarket/http-api'

export const GOOD_DEED_INFORMATION_2 = {
  [MarketCountryCode.US]: false,
  [MarketCountryCode.GB]: false,
  [MarketCountryCode.JP]: false,
  default: true,
}

export const COUNTRIES_WITHOUT_BENEFIT_3 = {
  [MarketCountryCode.GB]: false,
  [MarketCountryCode.JP]: false,
  default: true,
}
